import { withInstall } from '../../../utils/with-install'
import Geolocation from './Geolocation.vue'

export const ElAmapControlGeolocation = withInstall(Geolocation)
export default ElAmapControlGeolocation
